import React, { useEffect } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { Link } from "react-router-dom";
import "../../css/MenuButton.css";
import BackgroundSketch from "./BackgroundSketch";

function MenuButton({ isMenuOpen, setIsMenuOpen }) {
  const handleToggle = () => setIsMenuOpen(!isMenuOpen);
  const handleClose = () => setIsMenuOpen(false);

  // 🔹 Dispatch custom event instead of reloading
  const handleRefresh = () => {
    window.dispatchEvent(new Event("menuBackgroundRefresh"));
  };

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "";
    if (isMenuOpen) window.scrollTo({ top: 0, behavior: "smooth" });
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  return (
    <>
      <div className="navbar-button navbar-button-left" onClick={handleToggle}>
        {isMenuOpen ? (
          <FiX size={28} style={{ color: "var(--background-colour)" }} />
        ) : (
          <FiMenu size={28} />
        )}
      </div>

      <div className={`menu-overlay ${isMenuOpen ? "open" : "closed"}`}>
        <div className="menu-background">
          <BackgroundSketch invert={true} />
        </div>

        {/* 🔹 Refresh button */}
        {isMenuOpen && (
          <div
            className="menu-refresh-button"
            onClick={handleRefresh}
          >
            <p className="menu-refresh-text">tap here</p>
          </div>
        )}

        <div className="menu-items">
          <Link to="/" onClick={handleClose} className="menu-button">HOME</Link>
          <Link to="/about" onClick={handleClose} className="menu-button">ABOUT</Link>
          <Link to="/collections" onClick={handleClose} className="menu-button">SHOP BY ARTIST</Link>
          <Link to="/collections/all" onClick={handleClose} className="menu-button">SHOP ALL</Link>
        </div>
      </div>
    </>
  );
}

export default MenuButton;